module.exports = __webpack_public_path__ + "img/podium.6aef3b8e.png";